import { useEffect, useState } from "react";
import { LEAVE_TYPES } from "./leaveEarningsData";
import { loadLeaveEarningTypes } from "./leaveEarningsApi";

// Leave Type options for the Add / Edit form and the import, loaded from
// GET payroll/earning/leave/earning/types/ each time `open` turns true.
// Until they arrive, or if the call fails or returns nothing, the built-in
// LEAVE_TYPES are used so the form still works.
export const useLeaveEarningTypes = (domain, open) => {
  const [types, setTypes] = useState(LEAVE_TYPES);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !domain) return undefined;
    const controller = new AbortController();
    setLoading(true);
    loadLeaveEarningTypes(domain, controller.signal)
      .then((list) => { if (!controller.signal.aborted) setTypes(list.length ? list : LEAVE_TYPES); })
      .catch(() => { if (!controller.signal.aborted) setTypes(LEAVE_TYPES); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [open, domain]);

  return { types, loading };
};
